export default __webpack_public_path__ + "cover-new.d21f5516.png";